import React, {Component} from 'react';
import {
    Route,
    Switch,
    Redirect
} from 'react-router-dom';

import logo from './logo.svg';
import './App.css';
import appRoutes from 'routes/app';
import Footer from "./component/Footer";

class App extends Component {

    render() {
        return (
            <div className="wrapper">
                {/*<NotificationSystem ref="notificationSystem" style={style}/>*/}
                {/*<Sidebar {...this.props} />*/}
                <div id="main-panel" className="main-panel">
                    {/*<Header {...this.props}/>*/}
                    <Switch>
                        {
                            appRoutes.map((prop,key) => {
                                if(prop.redirect)
                                    return (
                                        <Redirect from={prop.path} to={prop.to} key={key}/>
                                    );
                                return (
                                    <Route path={prop.path} component={prop.component} key={key}/>
                                );
                            })
                        }
                    </Switch>
                    <Footer />
                </div>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js